// 内容详情
<template>
  <div>
    <div class="title">{{ currArticleInfo.title }}</div>
    <el-row type="flex" style="color:#333;text-align:center;" justify="center">
      <el-col class="grid-content" :span="6"
        >用户名：{{ currArticleInfo.userName }}</el-col
      >
      <el-col class="grid-content" :span="6"
        >发布时间：{{ currArticleInfo.creationTime }}</el-col
      >
    </el-row>
    <el-form :disabled="true" label-width="80px" size="mini">
      <!-- <el-form-item label="标题:">
        <span>{{ currArticleInfo.title }}</span>
      </el-form-item> -->
      <el-form-item label="内容:">
        <div v-if="currArticleInfo.contentType===1">
        <p>
          {{ currArticleInfo.content }}
        </p>
        <el-row style="width:60%" :gutter="10" v-if="currArticleInfo.imgUrl.length">
          <el-col
            class="grid-content"
            :span="8"
            v-for="(v2, i2) in currArticleInfo.imgUrl.split(',')"
            :key="i2"
          >
            <el-image
              class="car"
              :src="apiUrl + v2"
              :preview-src-list="[apiUrl + v2]"
            >
            <div slot="error" class="el-image__error">
                         {{ !v2?'暂无图片':'加载失败' }} 
                        </div>
            </el-image>
          </el-col>
        </el-row>
      </div>
      <div v-if="currArticleInfo.contentType===0">
       <div class="ql-editor" v-html="currArticleInfo.content"></div>
      </div>
      </el-form-item>
      <!-- <el-form-item label="发布时间:">
        <span> {{ currArticleInfo.creationTime }}</span>
      </el-form-item> -->
      <el-form-item label="" class="tags" v-if="isShowSign != 2">
        <div>
          <span class="img"><img src="../assets/images/tag.png" alt=""/></span>
          <span
            style="margin-right:0.1rem;"
            v-for="(item, idx) in currArticleInfo.sysSignStr.split(',')"
            :key="idx"
            >{{ item }}</span
          >
        </div>
      </el-form-item>
      <el-form-item label="" class="data" v-if="isShowSign != 2">
        <span
          ><i class="el-icon-view"></i
          ><b>{{ currArticleInfo.readCount }}</b></span
        >
        <span
          ><img src="../assets/images/dianzan.png" alt="" /><b>{{
            currArticleInfo.thumbUpCount
          }}</b></span
        >
        <span
          ><i class="el-icon-chat-line-round"></i
          ><b>{{ currArticleInfo.commentCount }}</b></span
        >
        <span
          ><i class="el-icon-star-off"></i
          ><b>{{ currArticleInfo.collectCount }}</b></span
        >
      </el-form-item>
    </el-form>
    <!-- <el-divider></el-divider> -->
    <!-- <div>
      <el-row class="detail" :gutter="50">
        <el-col v-if="currArticleInfo.businessName != null" :span="8"
          >企业名称：{{ currArticleInfo.businessName }}</el-col
        >
        <el-col :span="8">用户名：{{ currArticleInfo.userName }}</el-col>
        <el-col :span="8">真实姓名：{{ currArticleInfo.name }}</el-col>
        <el-col :span="8" v-if="isShowSign != 2"
          >标签：{{ currArticleInfo.sysSignStr }}</el-col
        >
        <el-col :span="8">发布时间：{{ currArticleInfo.creationTime }}</el-col>
        <el-col :span="8">阅读数：{{ currArticleInfo.readCount }}</el-col>
        <el-col :span="8">点赞数：{{ currArticleInfo.thumbUpCount }}</el-col>
        <el-col :span="8">评论数：{{ currArticleInfo.commentCount }}</el-col>
        <el-col :span="8">收藏数：{{ currArticleInfo.collectCount }}</el-col>
      </el-row>
    </div> -->
  </div>
</template>
<script>
export default {
  props: { currArticleInfo: {}, isShowSign: { default: 2 } },
  data() {
    return {
      apiUrl: ""
    };
  },
  created() {
    this.apiUrl = window.api.apiurl;
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
>>> .el-form-item {
  margin-bottom: 0rem;
}
.data {
  display: flex;
  >>> .el-form-item__content {
    display: flex;
  }
  span {
    width: 0.8rem;
    display: flex;
    font-size: 0.16rem;
    color: #666;
    flex-wrap: nowrap;
    align-items: center;
    b {
      vertical-align: middle;
      font-size: 0.16rem;
    }
    img {
      margin-right: 0.1rem;
      vertical-align: middle;
    }
    i {
      font-size: 0.18rem;
      margin-right: 0.1rem;
      color: #666666;
    }
  }
}
.tags {
  color: #198cff;
  line-height: 0.2rem;
  span {
    vertical-align: middle;
  }
  .img img {
    width: 0.2rem;
    height: 0.2rem;
  }
}
.title {
  font-size: 0.24rem;
  color: #333;
  text-align: center;
  font-weight: bold;
}
p {
  // line-height: 2;
  // margin-top: 0.06rem;
}
img.car {
  border: 1px solid #dedede;
  width: 100%;
  max-width: 2rem;
  background: #eeeeee;
  box-sizing: border-box;
  border-radius: 0.05rem;
  margin: 0.1rem 0;
}
>>> .car {
  border: 1px solid #dedede;
  width: 100%;
  max-width: 2rem;
  background: #eeeeee;
  box-sizing: border-box;
  border-radius: 0.05rem;
  margin: 0.1rem 0;
}
.detail {
  line-height: 2;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/contentDetail.vue